module.exports = __webpack_public_path__ + "img/courier_dire.01a824b4.png";